export const GATE_STAGE = {
  required: 'required',
  requesting: 'requesting',
  blocked: 'blocked',
  failed: 'failed',
};

export const geolocationCopy = {
  cancelLabel: 'Cancel',
  [GATE_STAGE.required]: {
    title: 'Location Sharing Required',
    body: [
      "Motivity 360 uses your device's precise GPS location to support the application's core functions.",
    ],
    primaryLabel: 'Allow',
  },
  [GATE_STAGE.requesting]: {
    title: 'Getting your location…',
  },
  [GATE_STAGE.blocked]: {
    title: 'Location Access Required',
    body: [
      'Location access is required to clock {{in|out}}.',
      'Please allow location access for this website in your browser settings, then return and tap **Try Again**.',
    ],
    primaryLabel: 'Try Again',
  },
  [GATE_STAGE.failed]: {
    title: "We couldn't get your location",
    body: [
      "Please make sure your device's location is turned on and location access is allowed for this website.",
      'Once enabled, return to this page and tap **Try Again**.',
    ],
    primaryLabel: 'Try Again',
  },
};
